<div class="view-qr-code-modal">
  <div class="view-qr-code-modal__header">
    <p class="view-qr-code-modal__header-title">
      {{ 'VIEW_QR_CODE.TITLE' | translate }}
    </p>
    <mat-icon
      class="view-qr-code-modal__header-close"
      [matTooltip]="'VIEW_QR_CODE.CLOSE' | translate"
      [matTooltipPosition]="'left'"
      mat-dialog-close
      >close</mat-icon
    >
  </div>

  <div class="view-qr-code-modal__content">
    <img id="qr-code-img" width="256" height="256" />
    <p class="view-qr-code-modal__content-text">{{ data.qrCode }}</p>
  </div>

  <div class="view-qr-code-modal__footer">
    <button
      class="view-qr-code-modal__footer-button"
      type="button"
      mat-raised-button
      color="primary"
      (click)="downloadQrCode()"
    >
      {{ 'VIEW_QR_CODE.DOWNLOAD' | translate }}
    </button>
  </div>
</div>
